import * as React from "react";
import { Box, Stack } from "@origin-digital/ods-core";
import { Text, BREAK_POINTS } from "@origin-digital/style-guide";
import styled from "styled-components";
import { Link } from "react-router-dom";

const PlainLink = styled(Link)`
  text-decoration: none;
  width: 100%;
`;

const QuickLinkContainer = styled(Box)`
  height: 140px;
  background-color: white;
  display: flex;

  text-align: center;
  align-items: center;
  justify-content: center;

  & svg {
    transition: transform 0.22s;
    height: 36px;
    width: 36px;
  }

  @media (min-width: ${BREAK_POINTS.Min.SM}) {
    height: 160px;

    & svg {
      height: 46px;
      width: 46px;
    }
  }

  &:hover svg {
    transform: scale(1.3);
  }
`;

export interface IQuickLink {
  title: string;
  icon: React.ReactNode;
  link: string;
}

export const QuickLink = ({ title, icon, link }: IQuickLink) => {
  return (
    <PlainLink to={link}>
      <QuickLinkContainer
        className="QuickLinkContainer"
        data-id="quicklink-container"
        padding="medium"
        width="full"
      >
        <Stack space="medium" alignX="center">
          {icon}
          <Text>{title}</Text>
        </Stack>
      </QuickLinkContainer>
    </PlainLink>
  );
};
